const ITEMS = [
  "1938 — 2026",
  "Patriarche de Banigbé-Gare",
  "Opérateur Économique",
  "Entrepreneur Agricole",
  "Bâtisseur de communauté",
  "Pilier de famille",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="tribute-marquee"
      className="overflow-hidden border-y border-[#C5A059]/25 bg-[#F4EFEA]/90 py-4"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {row.map((item, i) => (
          <span
            key={i}
            className="mx-6 flex items-center gap-6 font-display text-base italic text-stone-600 sm:text-lg"
          >
            {item}
            <span className="text-[#C5A059]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
